import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function TermsConditions() {
  let { language } = useContext(AuthContext);
  const {t} = useTranslation();
  const [slugContent, setSlugContent] = useState();
  const location = useLocation().pathname.slice(1, useLocation().pathname.length);

  useEffect(() => {
    const staticPage = async () => {
      const pathContent = pathObj.staticContentSlug;
      const resultContent = await apiGet(pathContent + "=" + location);
      setSlugContent(resultContent?.data?.results?.content);
    };
    staticPage();
  }, [language, location]);

  return (
    <>
      <Toolbar title={t("TERMS_OF_USE")} showBackBtn={true} />
      <section className="banner-part container p-10">
        <span>{slugContent ? parse(slugContent) : null}</span>
      </section>
    </>
  );
}

export default TermsConditions;
